/* 权限展示表 */
<template>
  <div class="permissions-tabel">
    <Row type="flex" justify="start" v-for="(item, index) in permissionsList" :key="index">
      <Col span="3" class="title">{{item.name}}</Col>
      <Col span="21">
        <Row type="flex" :gutter="30" justify="start" class="tabel">
          <Col v-for="(list, i) in item.childPermission" :key="i">
            <span class="point"></span>
            <span class="text">{{list.name}}</span>
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
</template>
<script>
import { PERMISSIONS } from "@/constants/permissions.js";
export default {
  data() {
    return {
      PERMISSIONS: PERMISSIONS
    };
  },
  props: {
    permissionsList: {
      type: [Array, String],
      default: ''
    }
  }
};
</script>

<style lang="scss">
.permissions-tabel {
  margin-top: 30px;
  line-height: 120px;
  .title {
    font-size: 16px;
    font-weight: 500;
    color: rgba(49, 49, 49, 1);
  }
  .tabel {
    min-height: 120px;
    line-height: 120px;
    background: #f6f6f6;
    padding: 0 40px;
    margin-bottom: 50px;
    .point {
      display: inline-block;
      width: 10px;
      height: 10px;
      background: #707070;
      border-radius: 50%;
      vertical-align: middle;
      margin-right: 15px;
    }
    .text {
      font-size: 16px;
      font-weight: 500;
      color: rgba(112, 112, 112, 1);
    }
  }
}
</style>

